import { FORM_BUILDER_FIELD_TYPE, formBuilderMapper, ButtonSizeOptions } from "@loanbossinc/component-library";

export const rows = isLoading => ({
  title: {
    label: "Individual Owners",
    isTitle: true
  },
  owners: {
    hasNestedRows: true,
    key: "individualOwners",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NESTED,
        Cell: formBuilderMapper,
        label: "Property Projections",
        style: { width: "100%" },
        subComponents: [
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
              key: "principleOwnerId",
              name: `individualOwners[${index}].principleOwnerId`,
              componentorder: 0,
              collectionname: "individualOwners",
              variant: "filled",
              displayWith: option => option.name,
              setValueWith: option => option.id
            })
          },
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.BUTTON,
              label: "Remove Owner",
              size: ButtonSizeOptions.lgFluid,
              disabled: isLoading,
              name: `individualOwners[${index}].id`,
              style: { width: "214px", marginTop: "10px", float: "right", border: "none" },
              onClick: (value, formik) => {
                if (value) {
                  let individualOwners = formik.values.individualOwners;
                  individualOwners = individualOwners.filter(individualOwners => individualOwners.id !== value);
                  formik.setValues({ ...formik.values, individualOwners });
                }
              }
            })
          }
        ]
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.NESTED,
        Cell: formBuilderMapper,
        subComponents: [
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.PERCENT,
              label: "Ownership Percentage",
              name: `individualOwners[${index}].ownershipPercentage`,
              variant: "filled",
              decimals: 2,
              style: { marginTop: "10px", marginLeft: "0" }
            })
          }
        ]
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.NESTED,
        Cell: formBuilderMapper,
        subComponents: [
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.SWITCH,
              label: "External Equity",
              altlabel: "Internal Equity",
              name: `individualOwners[${index}].isExternalEquitySource`
            })
          }
        ]
      }
    ]
  },
  addRecord: {
    key: "addRecord",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Add a new individual owner"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.BUTTON,
        label: "Add",
        hideLabel: true,
        disabled: isLoading,
        size: ButtonSizeOptions.sm,
        onClick: (value, formik) => {
          const individualOwners = formik.values.individualOwners;
          individualOwners.splice(formik.values.individualOwners.length, 0, { propertyId: formik.values.id, principleOwnerId: null, isExternalEquitySource: false, ownershipPercentage: 1, principleType: "individual" });
          formik.setValues({ ...formik.values, individualOwners });
        },
        style: { width: "132px", marginTop: "10px", float: "right" }
      }
    ]
  }
});
